import $ from 'jquery';

import { SELECTORS, IS_VISIBLE, ALL_CHECKED } from './constants';
import { trackFilterEvent } from './helpers';

function initializeDropDownEvents($form) {
  registerDropDownEventListeners();

  function registerDropDownEventListeners() {
    const $dropDown = $form.find(SELECTORS.DROPDOWN);
    $('body').on('click', event => onBodyClick(event, $dropDown));
    $form.on('checkbox:reset', onCheckboxReset);
    $form.on('checkbox:updateLabel', (e, dropdown) => updateCheckboxButtonLabel(dropdown));
    $form.on('click', SELECTORS.DROPDOWN_TRIGGER, onDropdownClick);
    $form.on('click', SELECTORS.ALL_CHECKBOX, handleAllCheckboxClick);
    $form.on('click', SELECTORS.CHECKBOX, handleCheckboxChange);
  }

  function onCheckboxReset() {
    $form.find(SELECTORS.DROPDOWN).map((index, el) => {
      const $el = $(el);
      $el.removeClass(IS_VISIBLE);
      return updateCheckboxButtonLabel($el.find('ul'));
    });
  }

  function onBodyClick(e, $dropDown) {
    const $target = $(e.target);
    if (!$target.is(SELECTORS.DROPDOWN) && !$target.closest(SELECTORS.DROPDOWN).length) {
      $dropDown.removeClass(IS_VISIBLE);
    }
  }

  function onDropdownClick() {
    const $currentDropdown = $(this).parent(SELECTORS.DROPDOWN);
    const $otherDropDowns = $form.find(SELECTORS.DROPDOWN).not($currentDropdown[0]);
    $currentDropdown.toggleClass(IS_VISIBLE);
    $otherDropDowns.removeClass(IS_VISIBLE);
  }

  function updateCheckboxButtonLabel($options) {
    let $buttonText = '';
    const $button = $options.siblings('button');
    const $tickedCheckbox = $options.find(SELECTORS.CHECKBOX_CHECKED);
    $tickedCheckbox.map((index, el) => {
      $buttonText += `${$(el).data('label')}`;
      if (index !== $tickedCheckbox.length - 1) {
        $buttonText += ', ';
      }
      return $buttonText;
    });
    return $button.text($buttonText);
  }

  function handleCheckboxChange(e) {
    const $target = $(e.target);
    trackFilterEvent('Dropdown click', `${$target.data('label')} - ${$target.prop('checked')}`);
    const isAllCheckbox = e.target.value === ALL_CHECKED;
    const $allCheckbox = $target.closest('ul').find(SELECTORS.ALL_CHECKBOX);
    $allCheckbox.prop('checked', isAllCheckbox);

    const $checkboxesChecked = $target.closest('ul').find(SELECTORS.CHECKBOX_CHECKED);
    if ($checkboxesChecked.length === 0) {
      $allCheckbox.prop('checked', true);
    } else if ($checkboxesChecked.length === 3) {
      $checkboxesChecked.prop('checked', false);
      $allCheckbox.prop('checked', true);
    }
    updateCheckboxButtonLabel($target.closest('ul'));
    $form.submit();
  }

  function handleAllCheckboxClick(e) {
    const $target = $(e.target);
    const $otherCheckboxes = $target.closest('ul').find(SELECTORS.CHECKBOX);
    $otherCheckboxes.prop('checked', false);
    handleCheckboxChange(e);
  }
}

export { initializeDropDownEvents };
